<template>
    <div class="site-footer ">
        <!--
        <div class="row container">
            <div class="col col-s12">
        <img :src="$root.urlsite+'documenti/footerBM.png'" style="margin:0;"/>
        </div>
        </div>
-->




        <div class="row pad">
            <div class="col s12 m5m offset-mm">
                <h3>{{$teras.bvent.titolo}}</h3>
            {{$teras.bvent.citta}}, {{ $teras.bvent.iniziail  | data('D MMMM') }} - {{ $teras.bvent.finisceil  | data('LL') }}
            <div style="margin:20px 0 0 0;">security: {{axios.sessionID}}·{{$abs.row.evento}}·{{ $teras.version }}</div>
            </div>


            

            <div class="col s12 m6">
                <h3 v-html="$teras.lang.assistenzaSection"></h3>

                <div v-if="$teras.evento.id==136">
                    Per ricevere assistenza potete contattare 
                    <br />
                    I VIAGGI DI SALOMONE-ASCO SRL
                    <br />
                    Email <a href="'mailto:sisvet2024@iviaggidisalomone.it'" >sisvet2024@iviaggidisalomone.it</a> 
                </div>

                <div v-else>
                <div v-html="$teras.lang.assistenzaHelp"></div>
                {{$teras.evento.responsabile}}
                <br />
                Email <a :href="'mailto:'+$teras.evento.responsabileemail" >{{$teras.evento.responsabileemail}}</a> 
                </div>
            </div>

        </div>
       
    </div>
</template>

<script>
var moment = require('moment');
moment.locale('it');
export default {
  name: 'site-footer',
  filters: {
    data (value,formato) {
        return moment(value).format(formato)
    }
  }
}
</script>
<style>
.site-footer{
    background: #393a3a;
    
    color:#ffffff;
    margin: 0;
    padding: 20px 0 40px 0;
}.site-footer a{
    color:#ffffff;
}.social-link a{
    float:right;
}
.social-link a img {
    height: 32px;
}
</style>




// WEBPACK FOOTER //
// Site-footer.vue?192faf6a